export enum RedirectStrategies {
    APP_INIT = 'appInit',
    USER_LOGOUT = 'userLogout'
}
